import { MenuItems } from './menu-items/menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTabsModule } from "@angular/material/tabs";
import { MatNativeDateModule, MatOptionModule } from "@angular/material/core";
import { SpinnerComponent } from './spinner/spinner.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { AlertModule, AlertConfig } from 'ngx-bootstrap/alert';
import { CommonModule } from '@angular/common';
import { NoFile } from './no-file/no-file';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { NgbAlertModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import { DeleteConfirmModalComponent } from './delete-confirm-modal/delete-confirm-modal.component';


@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    SpinnerComponent,
    NoFile,
    DeleteConfirmModalComponent
  ],
  imports:[CommonModule,  MatSnackBarModule,FormsModule,AlertModule.forRoot()],
  exports: [
    FormsModule, ReactiveFormsModule,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    MatNativeDateModule,
    MatOptionModule,
    MatTabsModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatListModule,
    SpinnerComponent,
    AlertModule,
    CommonModule,
    NoFile,MatProgressSpinnerModule,
    NgbAlertModule,
    NgbPaginationModule,
    MatCheckboxModule,
    MatSlideToggleModule,NgxPaginationModule,
    DeleteConfirmModalComponent
   ],
  providers: [MenuItems,AlertConfig ]
})
export class SharedModule { }